import React from 'react';

const FormattedPrice = ({ price }) => (
  <span className="formatted-price">
    {` ${(Number(price) / 100).toFixed(2)} ₪`}
  </span>
);

export default FormattedPrice;
